var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import RouterModule from '../router';
import { BaseModule } from './../commons/BaseModule';
import TestDesign from './components/TestDesign.vue';
var CampaignsModule = (function (_super) {
    __extends(CampaignsModule, _super);
    function CampaignsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CampaignsModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.installRoutes(options);
            resolve(true);
        });
    };
    CampaignsModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    CampaignsModule.prototype.installRoutes = function (options) {
        var routerModule = options.appModule.getModuleByType(RouterModule);
        var complexRoutes = routerModule.complexRoutes;
        complexRoutes.addRawRouteAt('tests', {
            path: 'design',
            name: 'tests-design',
            component: TestDesign,
            props: true,
            meta: {
                isRoot: true
            }
        });
    };
    return CampaignsModule;
}(BaseModule));
export default CampaignsModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/_tests/index.ts
// module id = null
// module chunks = 